import { useState, useRef, useCallback } from "react";
import { Dialog } from "@headlessui/react";
import "./index.css";
import useModalData from "../../hooks/useModalData";
import UserModal from "./UserModal";
import { X } from "lucide-react";

export default function UsersModal({ isOpen, setIsOpen }) {
  const [pageNum, setPageNum] = useState(1);
  const { usersData, hasNextPage } = useModalData(pageNum);

  const intObserver = useRef();
  const lastItemRef = useCallback(
    (item) => {
      // if (isLoading) return

      if (intObserver.current) intObserver.current.disconnect();

      intObserver.current = new IntersectionObserver((posts) => {
        if (posts[0].isIntersecting && hasNextPage) {
          console.log("we are near the last item");
          setPageNum((prev) => prev + 1);
        }
      });

      if (item) intObserver.current.observe(item);
    },
    [hasNextPage]
  );

  const content = usersData.map((item, i) => {
    if (usersData.length === i + 1) {
      return <UserModal ref={lastItemRef} key={item.id} item={item} />;
    }
    return <UserModal key={item.id} item={item} />;
  });

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        as="div"
        className="fixed inset-0 z-50 flex flex-col items-center justify-start md:mt-3 md:justify-start">
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black opacity-70" />
        <Dialog.Title />
        <Dialog.Description />
        <div className="z-50 my-auto flex h-[27.7rem] w-full flex-col overflow-y-scroll rounded-xl bg-white pb-2 md:w-[48rem] lg:w-[56.25rem]">
          <div className="flex flex-row items-center justify-center">
            <h2 className="w-[90%] py-4 text-center text-2xl font-bold">
              Our Learners Work At
            </h2>
            <X className="h-6 w-6 text-black cursor-pointer" onClick={() => setIsOpen(false)} />
          </div>
          <div className="mx-2 grid grid-cols-1 gap-2 md:grid-cols-2">
            {content}
          </div>
        </div>
      </Dialog>
    </div>
  );
}
